import { MktuClassStore } from '@/store/Mktu/MktuClass'
import { mktuClassesList } from '@/store/Mktu/MktuClassesList'
import { SearchMktuClassStore } from '@/store/Mktu/SearchMktuClass'
import { makeAutoObservable } from 'mobx'

export class MktuStore {
  searchStore = new SearchMktuClassStore(mktuClassesList)
  selectedMktuClasses: MktuClassStore[] = []

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
  }

  addFoundClasses() {
    this.selectedMktuClasses = this.searchStore.selectedFoundClasses
  }

  setSelectedMktuClasses(mktuClasses: MktuClassStore[]) {
    this.selectedMktuClasses = mktuClasses
  }
}

export const mktuStore = new MktuStore()
